import React, { Component } from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import { Grid, Row, Col } from 'react-bootstrap'
import { get } from 'lodash'
import { withRouter } from 'react-router-dom'
import moment from 'moment'

import PinUserIcon from 'Assets/Images/icons/pinUser'
import { PATHS } from 'Config/Routing/paths'

import { AmbassadorContactDetailsForm } from './../../../../../Containers/Form/City/Ambassador/ContactDetails'
import { AmbassadorWrapper } from 'Components/City/Page/Ambassador/AmbassadorWrapper'
import { AmbassadorSection } from 'Components/City/Page/Ambassador/AmbassadorSection'
import { SectionTitle } from 'Components/Section/SectionTitle'
import { PageTitle } from 'Components/PageTitle'

import {
  getAmbassadorByIdGraphQL,
  updateAmbassadorById,
} from 'Reducers/Ambassador/actions'
import { getCities } from 'Reducers/City/actions'
import { uploadProfileImage } from 'Reducers/Upload/actions'
import { COUNTRY_CODE } from '../../../../../constants'
import StyledBreadcrumbs from '../../../../../Components/StyledBreadcrumbs'
import { theme } from '../../../../../Assets/Styles/theme'
import {
  shouldShowContractorType,
  shouldShowShowBaType,
  shouldShowGermanyPaymentId,
} from '../util'

class AmbassadorEdit extends Component {
  constructor(props) {
    super(props)
    this.state = {
      canShowContractorType: false,
      canShowBaType: false,
      canShowGermanyPaymentId: false,
    }

    this.ambassadorContactDetailsFormSubmitHandler = this.ambassadorContactDetailsFormSubmitHandler.bind(
      this,
    )
    this.ambassadorContactDetailsFormSubmitSuccessHandler = this.ambassadorContactDetailsFormSubmitSuccessHandler.bind(
      this,
    )
  }

  componentDidMount() {
    const ambassadorId = this.props.match.params.ambassadorId
    this.props.getCities()
    this.props.getAmbassadorById(ambassadorId)
  }

  componentDidUpdate(prevProps, state) {
    if (
      this.props.ambassador &&
      this.props.ambassador.city &&
      this.props.ambassador.city.country
    ) {
      const canShowContractorType = shouldShowContractorType(
        this.props.ambassador.city.country.code,
      )

      if (state.canShowContractorType !== canShowContractorType) {
        this.setState({ canShowContractorType })
      }

      const canShowBaType = shouldShowShowBaType(
        this.props.ambassador.city.country.code,
      )

      if (state.canShowBaType !== canShowBaType) {
        this.setState({ canShowBaType })
      }

      const canShowGermanyPaymentId = shouldShowGermanyPaymentId(
        this.props.ambassador.city.country.code,
      )

      if (state.canShowGermanyPaymentId !== canShowGermanyPaymentId) {
        this.setState({ canShowGermanyPaymentId })
      }
    }
  }

  render() {
    return (
      <AmbassadorWrapper>
        <StyledBreadcrumbs
          icon={
            <PinUserIcon style={{ width: 16, fill: theme.colors.primary }} />
          }
          breadcrumbs={[
            {
              label: 'Dashboard',
              link: `${PATHS.main.dashboard}`,
            },
            {
              label: 'Cities',
              link: `${PATHS.main.dashboard}${PATHS.dashboard.cities}`,
            },
            {
              label: 'Edit Brand Ambassadors',
              link: this.props.match.url,
            },
          ]}
        />
        <PageTitle>
          {this.props.ambassador.firstName} {this.props.ambassador.lastName}
          {this.props.ambassador.status && (
            <span className="status">({this.props.ambassador.status})</span>
          )}
        </PageTitle>

        {this.renderAmbassadorSections()}
      </AmbassadorWrapper>
    )
  }

  /**
   * Render ambassador sections
   *
   * @returns JSX.Element[]
   *
   */
  renderAmbassadorSections() {
    const { ambassador } = this.props

    return <div>{this.renderAmbassadorContactDetailsSection(ambassador)}</div>
  }

  /**
   * Render ambassador contact details section
   *
   * @returns JSX.Element[]
   *
   */
  renderAmbassadorContactDetailsSection() {
    return (
      <AmbassadorSection>
        <Grid fluid>
          <Row>
            <Col xs={12}>
              <SectionTitle>Contact Details</SectionTitle>
            </Col>
          </Row>
          <AmbassadorContactDetailsForm
            canShowContractorType={this.state.canShowContractorType}
            canShowBaType={this.state.canShowBaType}
            canShowGermanyPaymentId={this.state.canShowGermanyPaymentId}
            cities={this.props.cities}
            countryCode={
              this.props.ambassador.city
                ? this.props.ambassador.city.country.code
                : null
            }
            onSubmit={this.ambassadorContactDetailsFormSubmitHandler}
          />
        </Grid>
      </AmbassadorSection>
    )
  }

  ambassadorContactDetailsFormSubmitHandler(values) {
    const { updateAmbassadorById, uploadProfileImage } = this.props
    const { ambassadorId } = this.props.match.params

    const callbacks = {
      onSuccess: this.ambassadorContactDetailsFormSubmitSuccessHandler,
    }
    const countryCode = this.props.ambassador.city.country.code

    const payload = imageUrl => {
      const data = {
        first_name: values.firstName,
        last_name: values.lastName,
        mobile_phone: values.mobilePhone,
        city_id: values.cityId,
        business_number: values.abn,
        profile_picture: imageUrl,
        contractor_type: values.contractorType,
        date_of_birth:
          countryCode !== COUNTRY_CODE.NETHERLANDS
            ? moment(values.dateOfBirth).utc()
            : null,
        category: countryCode === COUNTRY_CODE.POLAND ? values.category : null,
      }

      if (countryCode == COUNTRY_CODE.GERMANY) {
        data['germanyContractData'] = {
          address: values.address,
          houseNumber: values.houseNumber,
          exactAddress: values.exactAddress,
          city: values.residenceCity,
          postalCode: values.postalCode,
        }

        data['germanyPayrollData'] = {
          middleName: values.middleName,
        }

        data['germanyPaymentId'] = values.germanyPaymentId
      }

      return data
    }

    const imageFile = get(values, 'profilePicture[0]')
    if (imageFile && imageFile.type) {
      uploadProfileImage(ambassadorId, imageFile, {
        onSuccess: imageUrl => {
          updateAmbassadorById(ambassadorId, payload(imageUrl), callbacks)
        },
      })
    } else {
      updateAmbassadorById(ambassadorId, payload(), callbacks)
    }
  }

  ambassadorContactDetailsFormSubmitSuccessHandler() {
    const { history } = this.props
    const { ambassadorId } = this.props.match.params
    const cityId = this.props.ambassador.city.id

    history.push(
      `${PATHS.main.dashboard}${
        PATHS.dashboard.cities
      }/${cityId}/ambassadors/${ambassadorId}`,
    )
  }
}

AmbassadorEdit.propTypes = {
  ambassador: PropTypes.object.isRequired,
  getAmbassadorById: PropTypes.func.isRequired,
  updateAmbassadorById: PropTypes.func.isRequired,
}

const mapStateToProps = state => ({
  ambassador: state.ambassadors.ambassadorById,
  cities: state.city.citiesList,
})

export default connect(
  mapStateToProps,
  {
    getAmbassadorById: getAmbassadorByIdGraphQL,
    getCities,
    updateAmbassadorById,
    uploadProfileImage,
  },
)(withRouter(AmbassadorEdit))
